import { NavLink, Outlet } from 'react-router-dom'
import { useDesktop } from '../lib/useDesktop.ts'
import { useKeyboardInset } from '../lib/useKeyboardInset.ts'
import { Icon, type IconName } from './Icon.tsx'
import { OfflineBanner } from './bits.tsx'

const TABS: readonly { to: string; label: string; icon: IconName; end?: boolean }[] = [
  { to: '/', label: 'Nákupy', icon: 'basket', end: true },
  { to: '/sablony', label: 'Šablony', icon: 'list_check' },
  { to: '/akce', label: 'Akce', icon: 'tag' },
  { to: '/skupina', label: 'Skupina', icon: 'users' },
]

/**
 * Mobil: hlavni zalozky dole na dosah palce (navrh v2). Skupina a ucet jsou
 * od navrhu v3 na zalozce Skupina — horni lista s nimi odjizdela a zdvojovala je.
 */
export function MainLayout() {
  const desktop = useDesktop()
  const keyboard = useKeyboardInset()

  // Na pocitaci je skupina, navigace i ucet v bocnim panelu (AppLayout).
  if (desktop) return <Outlet />

  return (
    <div className={`app-shell has-bottom-nav${keyboard > 0 ? ' keyboard-open' : ''}`}>
      <div className="page">
        <header className="app-top app-top-bare">
          <OfflineBanner />
        </header>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
      <nav className="bottom-nav" aria-label="Hlavní navigace">
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} end={tab.end ?? false} className="bottom-nav-link">
            <Icon name={tab.icon} size={22} />
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
